import React from 'react';
import { Link } from 'react-router-dom';
import { UsersIcon, ClockIcon, DollarSignIcon } from 'lucide-react';
export function KeyHighlights() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-421">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-422">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-423">
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-424">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-425">
              <UsersIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-426" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-427">
              Family Friendly
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-428">
              A great event for the whole family and an excellent introduction
              to shooting sports in a mentoring environment.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-429">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-430">
              <ClockIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-431" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-432">
              Thursday Evenings
            </h3>
            <p className="text-sm mb-2" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-433">
              <strong data-id="element-434">6:00pm - 9:00pm</strong>
              <br data-id="element-435" />
              (6:00 setup / 6:30 shooting begins)
            </p>
            <Link to="/Calendar.html" className="text-xs font-semibold hover:underline" style={{
            color: '#c8a84b'
          }} data-id="element-436">
              Check calendar for dates
            </Link>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-437">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-438">
              <DollarSignIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-439" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-440">
              Entry Fee
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-441">
              <strong data-id="element-442">$1.00</strong> entry fee per person per run. Affordable
              fun for everyone.
            </p>
          </div>
        </div>
      </div>
    </div>;
}